import { getCountryAvailability } from '@services/collection/Availability.service';
import { FC, ReactNode, useEffect, useState } from 'react';
import CountryAvailabilityComponent from '../../../country-availability-banner/CountryAvailabilityComponent';
import { WarningBannerProps } from '../Types';
import { CountryAvailability } from '@services/collection/Models';

interface CountryWarningBannerProps {
  warningBannerProps: WarningBannerProps;
  children: ReactNode;
}

const CountryWarningBanner: FC<CountryWarningBannerProps> = ({ warningBannerProps, children }) => {
  return (
    <CountryWarningBannerComponent warningBannerProps={warningBannerProps}>{children}</CountryWarningBannerComponent>
  );
};

const CountryWarningBannerComponent: FC<CountryWarningBannerProps> = ({ warningBannerProps, children }) => {
  const { clientId, countries, productGroups, period, comparisonPeriod, periodicity, productType, collectionDataType } =
    warningBannerProps;

  const [data, setData] = useState<CountryAvailability>();

  useEffect(() => {
    const fetchCountryAvailability = async () => {
      const controller = new AbortController();

      try {
        const response = await getCountryAvailability(
          controller,
          {
            clientId,
            countries: countries.map(({ label, value }) => ({ id: value, name: label, currency: '' })),
            productType,
            period,
            comparisonPeriod,
            productGroup: productGroups,
            periodType: periodicity,
            appliedFilters: [],
          },
          collectionDataType,
        );
        setData(response);
      } catch (error) {
        console.error(error);
        setData(undefined);
      }
    };

    fetchCountryAvailability();
  }, []);

  const { unavailableCountries = [] } = data ?? {};

  return (
    <>
      {data && (
        <CountryAvailabilityComponent
          subscribedCountries={countries}
          unavailableCountriesByPeriodAndPg={unavailableCountries}
        />
      )}
      {children}
    </>
  );
};

export default CountryWarningBanner;
